import axios from "axios";

export function deleteQrcode(qrcodeId) {
  var config = {
    method: "delete",
    url: `${process.env.VUE_APP_APIHOST}/gaa/qrcode/${qrcodeId}`,
    data: {
    }
  };
  return axios(config);
}

export function deletePromotion(data) {
  var config = {
    method: "delete",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.businessId}/promotions/${data.id}`,
  };
  return axios(config);
}

export function deleteShopTag(data) {
  let config = {
    method: "delete",
    url: `${process.env.VUE_APP_APIHOST}/gaa/tags/shops/${data.shopId}`,
    data: {
      tagName: data.tagName
    }
  };
  return axios(config);
}

export function deletePrinter(accountId, shop, data) {
  let config = {
      method: 'DELETE',
      url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/printers/${data.printer.did}`,
      params: shop,
      data
  }
  return axios(config);
}

export function purgePrinterQueue(accountId, shop, data) {
  let config = {
    method: 'DELETE',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/printers/${data.printer.did}/purge-queue`,
    params: shop,
    data
  }
  return axios(config);
}

export function removeActiveVendor(accountId, vendor_code) {
  let config = {
    method: 'DELETE',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/mw-setting-active`,
    data: { vendor_code }
  }
  return axios(config);
}

export function clearInvoiceSettings(accountId) {
  let config = {
    method: 'DELETE',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/invoice`,
    data: {
      key: 'clear_invoice_settings',
      label: '清除發票串接設定',
      dbTable: 'ddc_invoice_shops',
      type: 'string',
      value: '清除'
    }
  }
  return axios(config);
}

export function clearInvoiceTracks(accountId) {
  let config = {
    method: 'DELETE',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/invoice-tracks`,
    data: {
      key: 'clear_invoice_tracks',
      label: '清除當期字軌',
      dbTable: 'qinvoice_invoices',
      type: 'string',
      value: '清除'
    }
  }
  return axios(config);
}
